/* global alert */

import React from 'react'
import PropTypes from 'prop-types'

import _ from 'lodash'
import { connect } from 'react-redux'
import * as firebase from 'firebase'
import FlatButton from 'material-ui/FlatButton'
import Checkbox from 'material-ui/Checkbox'

import ReportEmail from './ReportEmail'
import withSettingsCard from '../withSettingsCard'

class DailyEmails extends React.Component {

  static propTypes = {
    style: PropTypes.object,
    teamId: PropTypes.string.isRequired,
    reportsEmails: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {
      email: ''
    }
  }

  handleEmailInputUpdated = event => {
    event.preventDefault()
    this.setState({ email: event.target.value })
  }

  getReportTypeSwitchDbPath = reportType => `teams/${this.props.teamId}/reportsEmails/${reportType}ReportEnabled`

  getReportsListDbPath = () => `teams/${this.props.teamId}/reportsEmails/list`

  addReportEmail = () => {
    const path = this.getReportsListDbPath()
    const ref = firebase.database().ref(path)
    const key = ref.push().key
    ref.child(key).set({
      address: this.state.email,
      disabled: false
    })
  }

  handleAddClicked = event => {
    event.preventDefault()
    const validationResult = this.validateEmailInput(this.state.email)
    if (validationResult.success) {
      this.addReportEmail()
      this.setState({ email: '' })
    }
    else {
      alert('Please, enter a valid email.')
    }
  }

  validateEmailInput = email => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return { success: re.test(email.toLowerCase()) }
  }

  handleRemoveClicked = (event, key) => {
    event.preventDefault()
    const path = `${this.getReportsListDbPath()}/${key}`
    firebase.database().ref(path).set(null)
  }

  handleEntryCheck = (event, key, isChecked) => {
    const path = `${this.getReportsListDbPath()}/${key}/disabled`
    firebase.database().ref(path).set(!isChecked)
  }

  handleReceiveTimeSheetsReportToggled = (event, isChecked) => {
    const path = `${this.getReportTypeSwitchDbPath('timesheets')}`
    firebase.database().ref(path).set(isChecked)
  }

  handleReceiveJobsReportToggled = (event, isChecked) => {
    const path = `${this.getReportTypeSwitchDbPath('jobs')}`
    firebase.database().ref(path).set(isChecked)
  }

  render() {
    const reportsList = this.props.reportsEmails && this.props.reportsEmails.list || {}
    const timeSheetsReportEnabled = this.props.reportsEmails && this.props.reportsEmails.timesheetsReportEnabled
    const jobsReportEnabled = this.props.reportsEmails && this.props.reportsEmails.jobsReportEnabled
    return (
      <div style={{ ...this.props.style, ...styles.container }}>
        <div style={styles.header}>Daily emails</div>
        <div style={styles.subheader}>Who should receive daily emails?</div>
        <div style={styles.add}>
          <input style={styles.input}
            value={this.state.email}
            onChange={this.handleEmailInputUpdated} />
          <FlatButton
            style={styles.addButton}
            labelStyle={styles.addLabel}
            label='Add'
            onTouchTap={this.handleAddClicked} />
        </div>
        <div style={styles.enable}>
          <Checkbox
            style={styles.checkbox}
            iconStyle={styles.checkboxIcon}
            label='Receive Summary of Time Sheets Report'
            checked={timeSheetsReportEnabled}
            onCheck={this.handleReceiveTimeSheetsReportToggled} />
          <div style={{ height: 6 }} />
          <Checkbox
            style={styles.checkbox}
            iconStyle={styles.checkboxIcon}
            label='Receive Summary of Jobs Report'
            checked={jobsReportEnabled}
            onCheck={this.handleReceiveJobsReportToggled} />
        </div>
        <div>
          Recipients
        </div>
        <div>
          { _.keys(reportsList).map(key =>
            <ReportEmail
              key={key}
              style={{ marginTop: 8 }}
              entry={reportsList[key]}
              onEntryCheck={(event, isChecked) => this.handleEntryCheck(event, key, isChecked)}
              onRemoveClicked={event => this.handleRemoveClicked(event, key)} />
          )}
        </div>
      </div>
    )
  }

}

const styles = {
  container: {
    textAlign: 'left',
    paddingTop: 20,
    paddingBottom: 20,
    marginLeft: 24
  },
  header: {
    fontSize: 18,
    fontWeight: 500,
    marginBottom: 8
  },
  subheader: {
    fontSize: 14,
    fontWeight: 300,
    marginBottom: 8
  },
  add: {
    display: 'flex',
    flexDirection: 'row',
    width: 366
  },
  input: {
    flex: 1,
    border: 'solid 1px rgba(0, 0, 0, 0.12)',
    borderRadius: 3,
    backgroundColor: '#fefefe',
    padding: '7px 3px 7px 11px',
    color: '#757575',
    fontSize: 14,
    marginRight: 8
  },
  addButton: {
    borderRadius: 3,
    backgroundColor: '#356992',
    minWidth: 64
  },
  addLabel: {
    color: 'white',
    fontSize: 14,
    fontWeight: 400
  },
  enable: {
    marginTop: 18,
    marginBottom: 18
  },
  checkbox: {
    fontWeight: 300,
    fontSize: 15
  },
  checkboxIcon: {
    marginRight: 6
  }
}

const mapStateToProps = state => ({
  teamId: state.firebase.team.metadata.value.id,
  reportsEmails: state.firebase.team.reportsEmails.value
})

export default connect(mapStateToProps)(withSettingsCard(DailyEmails))



// WEBPACK FOOTER //
// ./src/settings/modules/dailyEmails/DailyEmails.js